import { invoke } from '@shared/easyfy.decorators';
import { globalEvent } from '@shared/easyfy.core';
import componentService from '@webServices/component.service';

namespace Easyfy.Components {
  @invoke
  class ContactUsComponent {
    constructor() {}

    onInit() {
      globalEvent({
        type: 'submit',
        event: {
          action: 'contact-form-component-post',
          callback: ContactUsComponent.contactformPost,
        },
      });
    }

    static contactformPost(e: Event) {
      e.preventDefault();
      e.stopPropagation();

      const target = e.target as HTMLElement;
      const component = target.closest('[data-container="contactus-component"]');
      const button = component?.querySelector('button');

      button?.setAttribute('disabled', 'disabled');

      const name = component?.querySelector('[name="name"]');
      const sendemailto = component?.querySelector('[name="sendemailto"]');

      const message = component?.querySelector('[name="message"]');
      const customeremail = component?.querySelector('[name="customeremail"]');
      const subject = component?.querySelector('[name="subject"]:checked');
      const phone = component?.querySelector('[name="phone"]') as HTMLInputElement | null;
      const orderNumber = component?.querySelector('[name="ordernumber"]') as HTMLInputElement | null;
      var token = target.getAttribute('data-token');
      if (!token) return;

      componentService
        .ContactUs(
          {
            name: (name as HTMLInputElement).value,
            sendemailto: (sendemailto as HTMLInputElement).value,
            message: (message as HTMLInputElement).value,
            customerEmail: (customeremail as HTMLInputElement).value,
            subject: (subject as HTMLInputElement)?.value ?? '',
            phone: phone?.value,
            orderNumber: orderNumber?.value,
          },
          token
        )
        .then((response) => {
          const resultContainer = component?.querySelector('[data-container="contact-form-button"]');
          if (!resultContainer) return;
          resultContainer.innerHTML = response.data.partial;
          button?.removeAttribute('disabled');
          if (response.data.success) {
            (name as HTMLInputElement).value = '';
            (message as HTMLInputElement).value = '';
            (customeremail as HTMLInputElement).value = '';
            if (phone) phone.value = '';
            if (orderNumber) orderNumber.value = '';
          }
        });
      return false;
    }
  }
}
